import * as React from 'react'
import {
  IPaymentMethods,
  IRider,
  IRiderObject,
  IServicePricingType,
  ITripPassengerDetail,
  ITripRequestRiders
} from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import Modal from '../../ui/Modal'
import AddBtnIcon from '../../icons/ui/AddBtn'
import { Button, Popup, Select, Input } from '@mobiscroll/react-latest'
import { FREE_PAYMENT_METHOD, PCA_RIDER_TYPE } from 'src/constants/trip'
import DirectChargePanel from 'src/components/riders/riderdetails/payments/DirectChargePanel'
import { PaymentSourceContextType } from 'src/components/riders/riderdetails/payments/PaymentSourceContext'
import { Route, Switch } from 'react-router'
import AddCardModal from 'src/containers/riders/riderdetails/AddCardModal'

export interface ISetTripPassengerProps extends PaymentSourceContextType {
  history: any
  match: any
  pricingTypes: IServicePricingType[]
  paymentMethods: IPaymentMethods[]
  onClose: () => void
  passengerDetails: ITripPassengerDetail
  setTripPassengerDetails: (passengerDetails: ITripPassengerDetail) => void
  updateRiderCount: (totalRider: number) => void
  setTripRequestTotalRidersFare: (totalRidersFare: number) => void
  rider: IRiderObject
}

interface IAddFundsModalState {
  isSubmitting: boolean
  error: string
  selected: string
  amount: number | undefined
  passengerDetail: ITripPassengerDetail
  selectedTab: number
  selectedMethod: { value: string; text: string }
  selectedRiderType: { value: string; text: string }
  noOfPayment: number
}

interface IPcaConfirmationModalProps {
  isOpen: boolean
  handleOkClick?: (open: boolean) => void
}

export const PcaConfirmationModal = ({ isOpen, handleOkClick }: IPcaConfirmationModalProps) => {
  const [open, setOpen] = React.useState(false)

  React.useEffect(() => {
    setOpen(isOpen)
  }, [isOpen])

  return (
    <Popup aria-labelledby='pca-modal-title' aria-modal='true' isOpen={open} as='dialog'>
      <div className='p2'>
        <p id='pca-modal-title'>The payment for the PCA rider has been set to free.</p>
        <div className='flex justify-end mt1'>
          <Button
            ariaLabel='Acknowledge PCA rider free payment'
            className='mbsc-success-btn'
            onClick={() => {
              setOpen(false)
              if (handleOkClick) {
                handleOkClick(false)
              }
            }}
          >
            {'Ok'}
          </Button>
        </div>
      </div>
    </Popup>
  )
}

class SetTripPassengerModal extends React.Component<ISetTripPassengerProps, IAddFundsModalState> {
  constructor(props: ISetTripPassengerProps) {
    super(props)

    const paymentMethod = this.getPaymentMethods()[0]
    this.state = {
      isSubmitting: false,
      error: '',
      amount: undefined,
      selected: '',
      passengerDetail: {
        tripRequestRiders: [
          {
            fareType: paymentMethod ? paymentMethod.text : '',
            riderType: 'Adult',
            totalRider: 1,
            amount: 0,
            totalAmount: 0
          }
        ],
        attendant: false,
        disabilityApproved: false
      },
      selectedTab: 0,
      selectedMethod: this.getPaymentMethods()[0],
      selectedRiderType: { value: 'Adult', text: 'Adult' },
      noOfPayment: 0
    }
  }
  public componentDidMount() {
    this.setState(oldState => {
      const newState = { ...oldState }
      newState.passengerDetail = { ...this.props.passengerDetails }
      return newState
    })
  }

  public render() {
    const { rider, match, history } = this.props
    const defaultRiderOptions = [
      { value: 'RRFP Cardholders', text: 'Senior' },
      { value: 'Adult', text: 'Adult' },
      { value: 'Youth', text: 'Youth' },
      { value: 'Children', text: 'Children' }
    ]

    const riderOptions = this.props.pricingTypes.length
      ? this.props.pricingTypes
          .filter(r => r.isActive)
          .map(pricingType => ({
            value: pricingType.riderType,
            text: pricingType.riderType ? pricingType.riderType : ''
          }))
      : defaultRiderOptions

    const paymentMethods = this.getPaymentMethods()
    const { selectedRiderType } = this.state

    const addCardModal = (props: any) => {
      return <AddCardModal rider={rider} {...props} />
    }

    return (
      <>
        <Switch>
          <Route exact={true} path={`${match.path}/add-card`} component={addCardModal} />
        </Switch>
        <Modal>
          <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
            <div className='med-modal'>
              <span className='ModalAddTitle font-small weight-300 font-grey2 uppercase'>Passenger Details</span>
              <div className='mt1 border-top pt2 '>
                <ul className='pl0'>
                  <li className='g-flex g-line-b pb2 col-12 g-gap10'>
                    <div className='g-mt0-all col-4'>
                      <Select
                        placeholder='Select Rider'
                        data={riderOptions}
                        value={this.state.selectedRiderType ? this.state.selectedRiderType.text : ''}
                        onClose={this.onRiderTypeChange}
                        touchUi={false}
                        theme='ios'
                        themeVariant='light'
                        inputStyle='box'
                        label={'Rider'}
                        labelStyle='floating'
                      />
                    </div>
                    <div className='g-mt0-all col-4'>
                      <Select
                        disabled={selectedRiderType.value === 'PCA'}
                        placeholder='Select Method'
                        data={paymentMethods}
                        value={this.state.selectedMethod ? this.state.selectedMethod.text : ''}
                        onClose={this.onPaymentMethodChange}
                        touchUi={false}
                        theme='ios'
                        themeVariant='light'
                        inputStyle='box'
                        label={'Method'}
                        labelStyle='floating'
                      />
                    </div>
                    <div className='g-mt0-all col-2'>
                      <Input
                        className='h38'
                        name='No'
                        type='number'
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.onNoOfPaymentChange(e.target.value)}
                        value={`${this.state.noOfPayment}`}
                        label='No.'
                        theme='ios'
                        themeVariant='light'
                        inputStyle='box'
                        labelStyle='floating'
                      />
                    </div>
                    <div className='g-flex col-2'>
                      <label />
                      <AddBtnIcon
                        onClick={this.addPayment}
                        className='icon--48x48 cursor--pointer self-end svg-light-green'
                        aria-label='Add payment'
                      />
                    </div>
                  </li>
                  <PcaConfirmationModal isOpen={this.state.selectedRiderType.value === 'PCA'} />
                  <div className='spdm-modal-body'>
                    {this.props.passengerDetails
                      ? this.props.passengerDetails.tripRequestRiders.map((tripRequestRider, i) => (
                          <li
                            className={`g-flex g-space-between gap10 items-center ${i === 0 ? 'pt2' : 'pt1'}`}
                            key={`method-${tripRequestRider.fareType}-${i}`}
                          >
                            <label className='font-grey3 h5 g-w180'>
                              {i + 1}.{' '}
                              {tripRequestRider.riderType !== 'RRFP Cardholders'
                                ? tripRequestRider.riderType
                                : 'Senior'}
                            </label>
                            <label className='font-grey3 h5 g-w150'>{tripRequestRider.fareType}</label>
                            <div className='g-w100'>
                              <button
                                className='cursor--pointer font-grey h3 bg-white border-white'
                                onClick={() => this.decreasePaymentMethod(tripRequestRider)}
                              >
                                -
                              </button>
                              <span className='px2'>{tripRequestRider.totalRider}</span>
                              <button
                                className='cursor--pointer font-grey h3 bg-white border-white'
                                onClick={() => this.increasePaymentMethod(tripRequestRider)}
                              >
                                +{' '}
                              </button>
                            </div>
                            <div className='g-w100' />
                          </li>
                        ))
                      : null}
                  </div>
                </ul>
                <DirectChargePanel rider={rider} history={history} match={match} />
              </div>
              <div className='spdm-modal-footer'>
                <button type='button' className='SubmitButton custom-btn mbsc-green-btn' onClick={this.closeComponent}>
                  {UIMessages.common.close}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </>
    )
  }

  private increasePaymentMethod = (selected: ITripRequestRiders) => {
    const selectedIndex = this.props.passengerDetails.tripRequestRiders.indexOf(selected)
    const tripRequestRidersCopy = [...this.props.passengerDetails.tripRequestRiders]
    tripRequestRidersCopy[selectedIndex].totalRider += 1

    this.props.setTripPassengerDetails({
      ...this.props.passengerDetails,
      ...{ tripRequestRiders: tripRequestRidersCopy }
    })
  }
  private decreasePaymentMethod = (selected: ITripRequestRiders) => {
    const selectedIndex = this.props.passengerDetails.tripRequestRiders.indexOf(selected)
    const tripRequestRidersCopy = [...this.props.passengerDetails.tripRequestRiders]
    if (tripRequestRidersCopy[selectedIndex].totalRider > 1) {
      tripRequestRidersCopy[selectedIndex].totalRider -= 1
      return this.props.setTripPassengerDetails({
        ...this.props.passengerDetails,
        ...{ tripRequestRiders: tripRequestRidersCopy }
      })
    }
    if (tripRequestRidersCopy.length === 1) {
      return
    }
    tripRequestRidersCopy.splice(selectedIndex, 1)
    this.props.setTripPassengerDetails({
      ...this.props.passengerDetails,
      ...{ tripRequestRiders: tripRequestRidersCopy }
    })
  }

  private onPaymentMethodChange = (e: { value: string; valueText: string }) => {
    this.setState({
      selectedMethod: { value: e.value, text: e.valueText }
    })
  }

  private onRiderTypeChange = (e: { value: string; valueText: string }) => {
    if (e.value === PCA_RIDER_TYPE) {
      this.setState({
        selectedRiderType: { value: e.value, text: e.valueText },
        selectedMethod: FREE_PAYMENT_METHOD
      })
    } else {
      this.setState({
        selectedRiderType: { value: e.value, text: e.valueText },
        selectedMethod: this.getPaymentMethods()[0]
      })
    }
  }

  private onNoOfPaymentChange = (e: string) => {
    if (Number(e) > 0) {
      this.setState(oldState => {
        const newState = { ...oldState }
        newState.noOfPayment = Number(e)
        return newState
      })
    }
  }

  private addPayment = () => {
    if (this.state.noOfPayment === 0) {
      return
    }
    const newState = { ...this.props.passengerDetails }
    const riderPayment = this.props.passengerDetails.tripRequestRiders.find(
      riderPayment =>
        riderPayment.riderType === this.state.selectedRiderType.value &&
        riderPayment.fareType === this.state.selectedMethod.value
    )
    if (riderPayment) {
      const riderPaymentIndex = this.props.passengerDetails.tripRequestRiders.indexOf(riderPayment)
      newState.tripRequestRiders[riderPaymentIndex].totalRider += this.state.noOfPayment
      return this.props.setTripPassengerDetails({ ...newState })
    }
    newState.tripRequestRiders = [
      ...this.props.passengerDetails.tripRequestRiders,
      {
        fareType: this.state.selectedMethod.value,
        riderType: this.state.selectedRiderType.value,
        totalRider: this.state.noOfPayment
      }
    ]
    this.props.setTripPassengerDetails({ ...newState })
  }

  private closeComponent = () => {
    const totalRiders = this.props.passengerDetails.tripRequestRiders.reduce(
      (partialSum, n) => partialSum + n.totalRider,
      0
    )
    this.props.updateRiderCount(totalRiders)
    this.setRidersTotalFare()
    this.props.onClose()
  }
  private setRidersTotalFare = () => {
    const pricingTypes = this.props.pricingTypes
    const totalFares = this.props.passengerDetails.tripRequestRiders.reduce((partialSum, rider) => {
      const pricing = pricingTypes.find(priceType => priceType.riderType === rider.riderType)
      if (pricing) {
        return partialSum + pricing.fare * rider.totalRider
      }
      return partialSum
    }, 0)
    this.props.setTripRequestTotalRidersFare(totalFares)
  }

  private getPaymentMethods() {
    return this.props.paymentMethods.length
      ? this.props.paymentMethods
          .filter(p => p.activated)
          .map(method => ({ value: method.paymentName, text: method.paymentName }))
      : []
  }
}

export default SetTripPassengerModal



// WEBPACK FOOTER //
// ./src/components/trips/modal/SetTripPassengerModal.tsx